import { ART } from '../lib/art';

const DEFAULT_MASCOTS = [
  { src: ART.wave, className: '-left-28 top-28 rotate-[-10deg]' },
  { src: ART.tarot, className: '-right-28 top-[34rem] rotate-[9deg]' },
  { src: ART.coffee, className: '-left-24 top-[64rem] rotate-[7deg]' },
  { src: ART.map, className: '-right-24 bottom-32 rotate-[-8deg]' },
];

export default function PageMascots({ items = DEFAULT_MASCOTS }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0 hidden xl:block">
      {items.map((item, index) => (
        <img
          key={`${item.src}-${index}`}
          src={item.src}
          alt=""
          loading="lazy"
          className={`absolute w-24 2xl:w-32 opacity-55 drop-shadow-[0_18px_35px_rgba(249,115,22,0.16)] ${item.className}`}
        />
      ))}
    </div>
  );
}
